import React, { useState } from 'react';
import { Table as AntTable, Button, Modal, Typography, Image, Row, Col, Tag } from 'antd';
import { Descriptions, Divider } from 'antd';
import { SearchOutlined, AuditOutlined } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import dayjs from 'dayjs';
import DetailsModal from './DetailsModal';
import AuditCaseModal from './AuditCaseModal';
const { Title, Text } = Typography;

const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#4a4a4a",
  textAlign: 'center',
};

const Table = ({ data = [], loading = false, refetch }) => {
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [auditModalVisible, setAuditModalVisible] = useState(false);
  const [auditRecord, setAuditRecord] = useState(null);

  const renderCustomFields = (customFields) => {
    if (!customFields) return null;

    // รองรับทั้ง array format (ใหม่) และ object format (เก่า)
    let fieldsArray = [];
    
    if (Array.isArray(customFields)) {
      // Format ใหม่: array ของ objects [{number, title, value}, ...]
      fieldsArray = customFields;
    } else if (typeof customFields === 'object') {
      // Format เก่า: object {title: value, ...}
      fieldsArray = Object.entries(customFields).map(([title, value]) => ({
        number: 0,
        title,
        value
      }));
    } else {
      return null;
    }

    // เรียงลำดับ: NOTE. ขึ้นก่อน แล้วเรียงตาม number
    fieldsArray = [...fieldsArray].sort((a, b) => {
      const aIsNote = a.title === "NOTE." || a.title === "NOTE";
      const bIsNote = b.title === "NOTE." || b.title === "NOTE";
      
      // NOTE. ขึ้นก่อน
      if (aIsNote && !bIsNote) return -1;
      if (!aIsNote && bIsNote) return 1;
      if (aIsNote && bIsNote) return 0;
      
      // ถ้าไม่ใช่ NOTE. ให้เรียงตาม number
      return (a.number || 0) - (b.number || 0);
    });

    return fieldsArray.map((field) => {
      const { title, value } = field;
      
      // ตรวจสอบว่า value เป็น array ของ image URLs หรือไม่
      if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string' && value[0].startsWith('http')) {
        // Handle image URLs in custom fields
        return (
          <div key={title} style={{ marginBottom: 16 }}>
            <Text strong>{title}: </Text>
            <div style={{ marginTop: 8 }}>
              <Row gutter={[8, 8]}>
                {value.map((url, index) => (
                  <Col key={index} xs={12} sm={8} md={6}>
                    <Image
                      width="200%"
                      src={url}
                      alt={`${title} ${index + 1}`}
                      style={{ borderRadius: 4 }}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        );
      } else {
        // Handle regular text fields
        return (
          <Descriptions.Item key={title} label={title} span={3}>
            {Array.isArray(value) ? value.join(', ') : String(value)}
          </Descriptions.Item>
        );
      }
    });
  };


  const handleViewDetails = (record) => {
    setSelectedRecord(record);
    setDetailsModalVisible(true);
  };

  const handleCloseDetails = () => {
    setDetailsModalVisible(false);
    setSelectedRecord(null);
  };

  const columns = [
    {
      title: 'แอดมิน (ส่ง)',
      dataIndex: 'create_by_name',
      key: 'create_by_name',
      align: 'center',
      width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'แอดมิน (จัดการ)',
      dataIndex: 'finish_by_Name',
      key: 'finish_by_Name',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || '-'}</span>,
    },
    {
      title: 'Case Name',
      dataIndex: 'caseName',
      key: 'caseName',
      align: 'center',
      width: 120,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => (
        <span style={{ color: '#ff9800', fontWeight: 'bold' }}>
          {text || '-'}
        </span>
      ),
    },
    {
      title: 'Case 2',
      dataIndex: 'case2Display',
      key: 'case2Display',
      align: 'center',
      width: 200,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text, record) => (
        <span style={{ color: '#4caf50', fontWeight: 'bold' }}>{record.case2Display || '-'}</span>
      ),
    },
    {
      title: 'Case 3',
      dataIndex: 'case3Display',
      key: 'case3Display',
      align: 'center',
      width: 200,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text, record) => (
        <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
          {record.case3Display || '-'}
        </span>
      ),
    },
    {
      title: 'User ID',
      dataIndex: 'userId',
      key: 'userId',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => (
        <span style={{ color: '#f44336', fontWeight: 'bold' }}>
          {text || '-'}
        </span>
      ),
    },
    {
      title: 'เวลา เริมต้น - สิ้นสุด',
      dataIndex: 'startEndDate',
      key: 'startEndDate',
      align: 'center',
      width: 180,
      onHeaderCell: () => ({ style: headerStyle }),
      //render: (text, record) => <span style={{ color: '#333' }}>{dayjs(record.startEndDate).format('DD/MM/YYYY HH:mm') || '-'}</span>,
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => <span style={{ color: '#333', fontWeight: 500 }}>{text || 0}</span>,
    },
    {
      title: 'Note',
      dataIndex: 'note',
      key: 'note',
      align: 'center',
      width: 250,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => (
        <div style={{ 
          whiteSpace: 'pre-wrap', 
          textAlign: 'left',
          maxWidth: '250px',
          wordBreak: 'break-word',
          color: '#333'
        }}>
          {text || '-'}
        </div>
      ),
    },
    {
      title: 'Transaction ID',
      dataIndex: 'ts_id',
      key: 'ts_id',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (text) => (
        <span style={{ fontWeight: 'bold' }}>
          {text || '-'}
        </span>
      ),
    },
    {
      title: 'สถานะตรวจ',
      key: 'auditResult',
      align: 'center',
      width: 150,
      fixed: 'right',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (_, record) => {
        // ผลที่กดในหน้านี้ (CaseAudit) มาก่อนเสมอ
        if (record.auditResult === 'Pass') return <Tag color="green">ผ่าน</Tag>;
        if (record.auditResult === 'Fail') {
          return (
            <div>
              <Tag color="red">ผิด</Tag>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                {record.auditTopic || '-'}
              </div>
            </div>
          );
        }

        // ยังไม่ได้ตรวจในหน้านี้ → ดูว่าตรวจไปแล้วที่หน้า Manual DEP มั้ย
        // (เคส Fail ส่วนใหญ่ตรวจกันที่นั่น จะได้ไม่ขึ้นว่า "ยังไม่ตรวจ" ทั้งที่ตรวจแล้ว)
        if (record.manualDepFail) {
          return (
            <div>
              <Tag color="red">ผิด</Tag>
              <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                จาก Manual DEP
                {record.manualDepRemark ? ` · ${record.manualDepRemark}` : ''}
              </div>
            </div>
          );
        }
        if (record.manualDepPass) {
          return (
            <div>
              <Tag color="green">ผ่าน</Tag>
              <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>จาก Manual DEP</div>
            </div>
          );
        }

        return <Tag>ยังไม่ตรวจ</Tag>;
      },
    },
    {
      title: 'รายละเอียด',
      key: 'details',
      align: 'center',
      width: 150,
      fixed: 'right',
      onHeaderCell: () => ({ style: headerStyle }),
      render: (_, record) => (
        <>
          <Button
            type="text"
            icon={<SearchOutlined style={{ color: '#1890ff', fontSize: '18px' }} />}
            onClick={() => handleViewDetails(record)}
            style={{ borderRadius: 6 }}
          />
          <Button
            type="text"
            title="ตรวจสอบเคสนี้"
            icon={<AuditOutlined style={{ color: '#fa8c16', fontSize: '18px' }} />}
            onClick={() => {
              setAuditRecord(record);
              setAuditModalVisible(true);
            }}
            style={{ borderRadius: 6 }}
          />
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: '20px', background: '#fff' }}>
      <div className='overflow-x-auto'>
        <AntTable
          loading={loading}
          dataSource={genNumberTable(data)}
          columns={columns}
           pagination={{
              position: ['topRight'],     // 👈 เลือกตำแหน่งได้
              // pageSize: 20,
            }}
          rowKey="id"
          scroll={{ x: 'max-content' }}
          bordered
          rowClassName={(record, index) => 
            index % 2 === 0 ? 'table-row-light' : 'table-row-light'
          }
        />
      </div>

      <DetailsModal
        visible={detailsModalVisible}
        onClose={() => {
          setDetailsModalVisible(false);
          setSelectedRecord(null);
        }}
        record={selectedRecord}
      />

      <AuditCaseModal
        visible={auditModalVisible}
        onClose={() => {
          setAuditModalVisible(false);
          setAuditRecord(null);
        }}
        record={auditRecord}
        onSaved={refetch}
      />

      <style>{`
        .table-row-light {
          background-color: #f5f5f5;
        }
        .ant-table-tbody > tr:hover > td {
          background-color: #e8f4f8 !important;
        }
      `}</style>
    </div>
  );
};

export default Table;

